module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "homeWorkContent"
  }, [(_vm.resourceList != '') ? _c('h4', {
    attrs: {
      "title": _vm.moduleInfo.moduleName
    }
  }, [_vm._v(_vm._s(_vm.moduleInfo.moduleName))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mdlContent"
  }, _vm._l((_vm.selectedTextNumArr), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('div', {
      staticClass: "main",
      on: {
        "click": function($event) {
          _vm.increment($event, item, item.resourceType)
        }
      }
    }, [_c('span', {
      staticClass: "noChoose",
      class: {
        'choose': item.isChecked
      }
    }), _vm._v(" "), (item.isPublished) ? _c('span', {
      staticClass: "publishedIcon"
    }, [_vm._v("布置过")]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "stitle",
      attrs: {
        "title": item.resourceName
      }
    }, [_vm._v(_vm._s(item.resourceName))]), _vm._v(" "), (item.isChecked) ? _c('span', {
      staticClass: "write",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.goDetail(item, index)
        }
      }
    }, [_vm._v(_vm._s(item.chooseText))]) : _vm._e()]), _vm._v(" "), ((_vm.moduleInfo.moduleId == 10 || _vm.moduleInfo.moduleId == 15 || _vm.moduleInfo.moduleId == 30 || _vm.moduleInfo.moduleId == 124 || _vm.moduleInfo.moduleId == 127 || _vm.moduleInfo.moduleId == 66) && item.isChecked) ? _c('chooseText', {
      key: index,
      attrs: {
        "moduleId": _vm.moduleInfo.moduleId,
        "item": item,
        "readTime": item.refLong,
        "serviceId": _vm.serviceId,
        "packageId": _vm.packageId,
        "readtimes": item.readtimes,
        "speekingtype": item.speekingtype,
        "cId": _vm.cId,
        "index": index
      },
      on: {
        "changeParams": _vm.changeParams
      }
    }) : _vm._e()], 1)
  }))])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3aab0370","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/homeWorkContent/homeWorkContent.vue
// module id = 1183
// module chunks = 1